export const BNB_ADMIN_LIST = ["Godfather", "Gangi", "Vocedelpadrino", "Bomb"];
export const PULSE_ADMIN_LIST = [
  "Godfather",
  "Creya",
  "kkkk",
  "Vocedelpadrino",
  "Akatsuki"
];
